import React, { useState } from "react"
import {
  Input,
  Form,
  Col,
  Row,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap"
import LogsTable from "./LogsTable"

// Custom Hooks
import useTableController from "hooks/useTableController"

// Validation
import { SearchFilterSchema } from "model/_base/filters/filter-options.schema";

// API
import { useGetLogsQuery } from "services/profile/api"

const modules = [
  { key: "all", label: "ทั้งหมด" },
  { key: "users", label: "ผู้ใช้งานระบบ" },
  { key: "auth", label: "ระบบยืนยันตัวตน" },
  { key: "campaigns", label: "แคมเปญ" },
  { key: "commission", label: "ค่าคอมมิชชัน" },
  { key: "content", label: "คอนเทนต์" },
  { key: "partners", label: "พาร์ทเนอร์" },
  { key: "products", label: "สินค้า" },
  { key: "profile", label: "โปรไฟล์" },
  { key: "settings", label: "ตั้งค่าระบบ" },
  { key: "transactions", label: "ธุรกรรม" },
]

const LogsTab = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false)
  const [selectedModule, setSelectedModule] = useState(modules[0])

  // HOOK CHANGE
  const { formik, searchInput, setSearchInput, handleTableChange } =
    useTableController({
      initialValues: {
        category: "",
      },
      validationSchema: SearchFilterSchema,
    })

  // API
  const { data, error, isLoading } = useGetLogsQuery(formik.values)

  // ACTIONS
  const toggleDropdown = () => setDropdownOpen(prevState => !prevState)

  const handleModuleSelect = module => {
    setSelectedModule(module)
    formik.setFieldValue("category", module.key === "all" ? "" : module.key)
  }

  // RENDER
  return (
    <Form
      className="form-horizontal w-100 d-flex flex-column gap-4"
      onSubmit={e => {
        e.preventDefault()
        formik.handleSubmit()
      }}
      data-testid="search-form"
    >
      <div className="activity-logs">
        <div className="header mt-4">
          <h2 className="fw-semibold">ประวัติการใช้งาน</h2>
          <div className="d-flex flex-column gap-2">
            <Row className="gy-3">
              <Col sm={12} md={4} lg={4}>
                <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                  <DropdownToggle caret>
                    {selectedModule.label || "เลือกหมวดหมู่"}
                  </DropdownToggle>
                  <DropdownMenu>
                    {modules.map(module => (
                      <DropdownItem
                        key={module.key}
                        onClick={() => handleModuleSelect(module)}
                        className={`${
                          selectedModule.key === module.key ? "active" : ""
                        }`}
                      >
                        {module.label}
                      </DropdownItem>
                    ))}
                  </DropdownMenu>
                </Dropdown>
              </Col>
              <Col sm={12} md={8} lg={{ offset: 1, size: 7 }}>
                <div className="d-flex gap-3">
                  <div className="flex-grow-1">
                    <div className="input-group-icon">
                      <i className="bx bx-search" />
                      <Input
                        name="searchTerm"
                        type="text"
                        placeholder="ค้นหาประวัติการใช้งาน"
                        onChange={e => setSearchInput(e.target.value)}
                        value={searchInput}
                        invalid={
                          formik.touched.searchTerm && formik.errors.searchTerm
                        }
                        data-testid="search-input"
                      />
                      {formik.touched.searchTerm &&
                        formik.errors.searchTerm && (
                          <div
                            className="error-message"
                            data-testid="search-error"
                          >
                            {formik.errors.searchTerm}
                          </div>
                        )}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>

        <LogsTable
          data={data}
          error={error}
          isLoading={isLoading}
          onTableChange={handleTableChange}
        />
      </div>
    </Form>
  )
}

export default LogsTab
